import gql from 'graphql-tag'
import { MultifactorCodeFormValues } from '..'
import { ErrorsTypes } from '../../../components/responses/setErrorNotifications'

export interface MultifactorAuthenticationCodeMutationVariables
  extends Readonly<{
    input: MultifactorCodeFormValues
  }> {}

export interface MultifactorAuthenticationCodeResponse {
  submitCode: MultifactorAuthenticationCodeOutput
}

export interface SendSmsCodeResponse {
  sendSmsCode: SendSmsCodeOutput
}

export type MultifactorAuthenticationCodeOutput = MultifactorAuthenticationCodeSuccess | ErrorsTypes

export type SendSmsCodeOutput = SendSmsCodeSuccess | ErrorsTypes

interface MultifactorAuthenticationCodeSuccess
  extends Readonly<{
    __typename: 'MultifactorAuthenticationCodeSuccess'
    accessToken: string
    refreshToken: string
    locationToken: string
    success: true
  }> {}

interface SendSmsCodeSuccess
  extends Readonly<{
    __typename: 'SendSmsCodeSuccess'
    success: true
  }> {}

export const MULTIFACTOR_AUTHENTICATION_CODE_MUTATION = gql`
  mutation MultifactorAuthenticationCode($input: MultifactorAuthenticationCodeInput!) {
    submitCode(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on GenericError {
        genericError: error {
          code
          message
        }
      }
      ... on MultifactorAuthenticationError {
        error {
          code
          message
        }
      }
      ... on MultifactorAuthenticationCodeSuccess {
        accessToken
        refreshToken
        locationToken
      }
    }
  }
`

export const SEND_SMS_VERIFICATION_CODE = gql`
  mutation SendSmsCode {
    sendSmsCode {
      __typename
      ... on MultifactorAuthenticationError {
        error {
          code
          message
        }
      }
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
    }
  }
`
